//  Login.js
//
//  Updated 3/1.
//
//  Abstract: Login page component.

//	React
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
//	Material-ui styles
import {
	makeStyles,
	Typography,
	Grid,
	Button,
	CircularProgress,
	Link,
	TextField
} from '@material-ui/core';
//	Components
import CardTemplate from '../__common__/CardTemplate/CardTemplate.js';
//	Hooks
import useFetch from '../../hooks/useFetch.js';

//	Define CSS styles
const useStyles = makeStyles((theme) => ({
	card: {
		marginTop: theme.spacing(10),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '10%'
	},
	form: {
		// width: '100%',
		marginTop: theme.spacing(1),
		justifyItems: 'center'
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	progess: {
		position: 'absolute'
	},
	logos: {
		width: '75px',
		justifyContent: 'center'
	},
	registerLink: {
		// color: 'darkblue',
		fontWeight: 'bold'
	}
}));

export default function Login(props) {

	//	Browser HTML history API
	const history = useHistory();

	//	CSS classes
	const classes = useStyles();

	//	useFetch
	const { post } = useFetch();

	//	Set state
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [errors, setErrors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoginSuccess, setIsLoginSuccess] = useState(false);

	useEffect(() => {
		if (isLoginSuccess) {
			history.push('/');
		}
	}, [isLoginSuccess]);

	//	Event handlers
	function handleEmailChange(event) {
		setEmail(event.target.value);
	}
	function handlePasswordChange(event) {
		setPassword(event.target.value);
	}
	function handleSubmit(event) {
		event.preventDefault();
		setIsLoading({ isLoading: true });
		const userData = {
			email: email,
			password: password
		};
		post('/login', userData)
			.then((data) => {
				if (data.token) {
					localStorage.setItem('AuthToken', `Bearer ${data.token}`);
					// console.log()
					setIsLoading(false);
					setIsLoginSuccess(true);
				} else {
					setErrors(data);
					console.log(data);
					setIsLoading(false);
				}
			})
			.catch((errors) => {
				setErrors(errors);
				console.log(errors);
				setIsLoading(false);
			});
	}

	//	Component rendering
	return (
		<>
			<CardTemplate>
				<form className={classes.form} >
					{errors.general && (
						<Typography variant="body2" className={classes.customError}>
							{errors.general}
						</Typography>
					)}
					<Grid container justify='center'>

						<Grid item justify='center'>
							<Link href="register" variant="body2" color={'secondary'} className={classes.registerLink}  >
								{"First time? Register."}
							</Link>
						</Grid>
					</Grid>
					<TextField
						variant="outlined"
						margin="normal"
						required
						fullWidth
						id="email"
						label="Email Address"
						name="email"
						autoComplete="email"
						color="secondary"
						autoFocus
						helperText={errors.email}
						error={errors.email ? true : false}
						onChange={handleEmailChange}
					/>
					<TextField
						variant="outlined"
						margin="normal"
						color="secondary"
						required
						fullWidth
						name="password"
						label="Password"
						type="password"
						id="password"
						autoComplete="current-password"
						helperText={errors.password}
						error={errors.password ? true : false}
						onChange={handlePasswordChange}
					/>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="tertiary"
						className={classes.submit}
						disableRipple
						onClick={handleSubmit}
						disableElevation
						disabled={isLoading || !email || !password}
					>
						Login
							{isLoading && <CircularProgress size={16} className={classes.progess} />}
					</Button>
					<Grid
						container
						direction="row"
						justify="center"
						alignItems="center"
						spacing={5}
					>
						<Grid item>
							<Link href="forgot" variant="body2" color='secondary'  >
								{"Forgot password?"}
							</Link>
						</Grid>
					</Grid>
				</form>
			</CardTemplate>
		</>
	);
}